import { PropTypes } from 'react';

const TableContent = ({ children }) => (
    <div className="cn-table__content">
        {children}
    </div>
);

TableContent.propTypes = {
    children: PropTypes.node
};

export default TableContent;



// WEBPACK FOOTER //
// ./app/components/table/content.jsx